export enum AppMode {
  test = 'test',
  development = 'development',
  staging = 'staging',
  production = 'production',
}
